<template>
    <custom-table
        :title="$t('pages.company.customer.title')"
        :subTitle="$t('pages.company.customer.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        filterComponentName="CompanyCustomerFilter"
        changeUrlPage
        @action="handleClickAction"
        @changeTable="handleTableChange">
        <template v-slot:fullName="{ row: record }">
            {{ record.customer.firstname + ' ' + record.customer.lastname }}
        </template>
        <template v-slot:email="{ row: record }">
            <a :href="'mailto:' + record.customer.email" class="text-gray-600 text-hover-primary mb-1">
                {{ record.customer.email }}
            </a>
        </template>
        <template v-slot:mobilePhone="{ row: record }">
            <a :href="'tel:' + record.customer.mobile_phone" class="text-gray-600 text-hover-primary mb-1">
                {{ record.customer.mobile_phone }}
            </a>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.detail')" placement="top">
                    <router-link :to="'/user/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/general/gen004.svg"/>
                     </span>
                    </router-link>
                </el-tooltip>
            </div>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/custom-table";
export default {
    name: "index",
    props: ['companyID', 'showUserBackButton'],
    components: {
        CustomTable
    },
    data(){
        return {
            fields: [
                {
                    name: this.$t("pages.company.customer.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.company.customer.cols.fullName"),
                    scopedSlots: {customRender: "fullName"},
                },
                {
                    name: this.$t("pages.company.customer.cols.email"),
                    scopedSlots: {customRender: "email"}
                },
                {
                    name: this.$t("pages.company.customer.cols.mobilePhone"),
                    scopedSlots: {customRender: "mobilePhone"},
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    computed: {
        table() {
            return this.$store.state.company.customer.table;
        },
    },
    mounted(){
        this.filterParameters = {
            sort: 'created_at:desc',
            company_id: this.companyID
        };

        this.$store.dispatch('company/customer/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
        });
    },
    methods: {
        refreshTable(){
            this.filterParameters = {
                sort: 'created_at:desc',
                company_id: this.companyID
            };

            this.$store.dispatch('company/customer/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                default:
                    break;
            }
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
                user_id: this.companyID
            }, filterData);

            this.$store.dispatch("company/customer/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
    }
}
</script>

<style>
.order-page-header:after {
    content: "";
    clear: both;
    display: table;
}
</style>